import styles from "@/styles/Video.module.scss";
import CourseInfo from "./CourseInfo";
import ProductInfo from "./ProductInfo";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function NoEntitled(_ref) {
  var watch = _ref.watch;
  var howtoPlay = watch.howtoPlay;

  if (howtoPlay.courses.length > 0) {
    return /*#__PURE__*/_jsxs("div", {
      className: styles.noentitled,
      children: [/*#__PURE__*/_jsx("h3", {
        children: "\u3053\u306E\u4F5C\u54C1\u3092\u3054\u8996\u8074\u3044\u305F\u3060\u304F\u306B\u306F\u4E0B\u8A18\u306E\u6708\u984D\u5546\u54C1\u306E\u8CFC\u5165\u304C\u5FC5\u8981\u3067\u3059\u3002"
      }), /*#__PURE__*/_jsx("div", {
        className: styles.contractInfo,
        children: howtoPlay.courses.map(function (course) {
          return /*#__PURE__*/_jsx(CourseInfo, {
            withLink: true,
            course: course,
            isLoggedIn: true
          }, "course-".concat(course.id));
        })
      })]
    });
  }

  if (howtoPlay.products.length > 0) {
    var header = howtoPlay.products.length > 1 ? "この作品をご視聴いただくには以下いずれかの購入が必要です。" : "この作品をご視聴いただくには別途料金が必要です。";
    return /*#__PURE__*/_jsxs("div", {
      className: styles.noentitled,
      children: [/*#__PURE__*/_jsx("h3", {
        children: header
      }), /*#__PURE__*/_jsx("p", {
        className: styles.caption,
        children: "\u5229\u7528\u306B\u3042\u305F\u3063\u3066\u306F\u898F\u7D04\u540C\u610F\u3068\u304A\u652F\u6255\u3044\u65B9\u6CD5\u306E\u767B\u9332\u304C\u5FC5\u8981\u3067\u3059\u3002"
      }), /*#__PURE__*/_jsx("div", {
        children: howtoPlay.products.map(function (product) {
          return /*#__PURE__*/_jsx(ProductInfo, {
            withLink: true,
            product: product,
            rights: howtoPlay.rights,
            isLoggedIn: true
          }, "product-".concat(product.id));
        })
      })]
    });
  }

  return /*#__PURE__*/_jsx("div", {
    className: styles.noentitled,
    children: /*#__PURE__*/_jsx("h3", {
      children: "\u3053\u306E\u4F5C\u54C1\u3092\u8996\u8074\u3044\u305F\u3060\u304F\u306E\u306B\u5FC5\u8981\u306A\u8CFC\u5165\u30FB\u5546\u54C1\u304C\u3042\u308A\u307E\u305B\u3093"
    })
  });
}